import React from 'react'
import { useTranslation } from 'react-i18next'
import { v4 } from 'uuid'
import PersonChangesLabelAndData from './PersonChangesLabelAndData'
import usePersonChangesTable from './usePersonChangesTable'

function OldChangesCell({ rows, idsMetadata, changeType }) {
  const { t } = useTranslation()
  const { sortRows } = usePersonChangesTable()
  const sortedRows = sortRows(rows)
  return (
    <>
      {sortedRows.map((row) => {
        let oldValue = ''
        if (row.oldValue) {
          oldValue = row.oldValue
          if (row.key === 'CHANGE_ID') {
            return null
          }

          if (row.key === 'SCOPE') {
            oldValue = t(`changes.fieldType.scope.${row.oldValue}`, row.oldValue)
          } else if (row.key === 'CONCLUSION_TYPE') {
            oldValue = t(`changes.fieldType.conclusionType.${row.oldValue}`, row.oldValue)
          } else if (row.key === 'DISMISSED_SUGGESTION_TYPE') {
            oldValue = t(`changes.fieldType.dismissedSubmissionType.${row.oldValue}`, row.oldValue)
          } else if (row.key === 'TYPE') {
            oldValue = t(`changes.fieldType.type.${row.oldValue}`, row.oldValue)
          } else if (row.key === 'RELATIONSHIP_TYPE') {
            oldValue = t(`changes.fieldType.relationshipType.${row.oldValue}`, row.oldValue)
          }
        }
        return (
          <PersonChangesLabelAndData
            key={v4()}
            label={t(`changes.field.label.${row.key}`, row.key)}
            data={oldValue}
            idsMetadata={idsMetadata}
            changeType={changeType}
          />
        )
      })}
    </>
  )
}

export default OldChangesCell
